import { BonusCustomerCondition, ConditionMode } from '@synergy/models';

export const getConditionValue = (condition: BonusCustomerCondition) => {
    const { price, percentage, mode } = condition.bonusCondition;
    const quantity = condition.bonusCondition.quantity || 1;

    if (mode === ConditionMode.Amount && price && quantity) {
        return price / quantity;
    }

    return percentage ?? 0;
};
